import LocatorApi from '@/lib/LocatorApi';
import { getTipByMaterial } from '@/lib/getTip';
import mapSearchParams from '@/lib/mapSearchParams';
export default async function materialLoader({ request, params, }) {
    const postcode = params.postcode;
    const localAuthority = LocatorApi.getInstance().get(`local-authority/${postcode}`);
    const url = new URL(request.url);
    const searchParams = mapSearchParams(['materials', 'category'], url.searchParams);
    const locations = LocatorApi.getInstance().get(`locations/${postcode}?${searchParams.toString()}`);
    const material = LocatorApi.getInstance().get(`materials/${url.searchParams.get('materials')}`);
    const tip = getTipByMaterial(url.searchParams.get('materials'));
    return {
        localAuthority,
        locations,
        tip,
        material,
    };
}
